import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import './styles/styles.scss';
import './pages/common/vhelper/inputStyle.css'; // Input date icon color
import { ThemeContextProvider } from './contexts/themeContext';
import './i18n';
import App from './App/App';
import UserContextProvider from './contexts/userContext';
import './pages/common/vhelper/scroll.css';
import { loadConfig } from './config';
import Errorpage from './pages/presentation/demo-pages/helper/Errorpage';

// Load config first, then render the app
loadConfig()
	.then(() => {
		ReactDOM.render(
			<Router>
				<React.StrictMode>
					<ThemeContextProvider>
						<UserContextProvider>
							<App />
						</UserContextProvider>
					</ThemeContextProvider>
				</React.StrictMode>
			</Router>,
			document.getElementById('root'),
		);
	})
	.catch((error) => {
		console.error('Failed to load config.json:', error);
		ReactDOM.render(<Errorpage />, document.getElementById('root'));
	});
